<template>
  <v-container class="app-page-container">
    <v-row>
      <v-col cols = "2"></v-col>  
      <v-col cols="8">
        <v-card>
          <v-card-text>
            <v-progress-linear v-if="status == 1"
              :value="progress" 
              height="10" 
              color="blue"                 
            ></v-progress-linear>
            <v-row style="margin: 2px;">
              <h2>{{ attemptsSuccesful }} / {{ attemptsCount }}</h2>
              <v-spacer />              
              <v-icon v-for="n in 3-currentError" :key="n" style="color:red;">favorite</v-icon>
            </v-row>
            <v-row style="margin: 2px;"><v-col></v-col></v-row>
            <v-row style="margin: 2px;user-select: none;" v-if="status == 1">
              <v-spacer />
                <h1>{{ displayedNumber }}</h1>
              <v-spacer />
            </v-row>
          <v-row style="margin: 2px;user-select: none;" v-if="status == 2">
            <v-text-field             
              v-model="userInput" 
              ref = "tta"
              label="Write number:" 
              outlined
              append-icon="done"
              @click:append="checkAnswer"
              @keyup.enter.prevent="checkAnswer"
              />
          </v-row>
          <div v-if="status == 3">
            <v-row style="margin: 2px;user-select: none;">
              <v-spacer />
              <h1 style="color:green;">{{ displayedNumber }}</h1>
              <v-spacer />
              <h1 v-if="displayedNumber == userInput" style="color:green;">{{ userInput }}</h1>
              <h1 v-if="displayedNumber != userInput" style="color:red;">{{ userInput }}</h1>
              <v-spacer />
            </v-row>      
          </div>         
          <div v-if="status == 0">
            <v-row style="margin: 10px;">
              <p></p>
              <p v-html="description"></p>
            </v-row>
            <v-row style="margin: 2px;">
              <v-spacer />
              <v-btn class="shadow-none" small @click="startTest">Start</v-btn>
              <v-spacer />
            </v-row>
          </div>

          <div v-if="status == 4">
            <v-row style="margin: 2px;">
              <v-spacer />
              <h1>Score: {{ score }}</h1>
              <v-spacer />
            </v-row>
            <v-row style="margin: 20px;">
              <v-col></v-col>
            </v-row>
            <v-row style="margin: 2px;">
              <v-spacer />
              <v-btn small class="shadow-none" @click="startTest">Restart</v-btn>
              <v-spacer />
              <v-btn small class="shadow-none" @click="closeTest">Close</v-btn>
              <v-spacer />
            </v-row>
          </div>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                ]),
    data() {
        return {
            status: 0, // 0 before start, 1 show number, 2 show edit, 3 result,  4 finish
            attemptsCount: 0, 
            attemptsSuccesful: 0,
            lengthAttempts: 3, // Max 3 attempts for every length
            maxErrors : 3,
            currentDigitCount: 2, 
            currentError: 0,
            displayedNumber: "", 
            userInput: "", 
            progress: 100, 
            interval: null, 
            score: 0,
            description: 'loading...',
            answers: [],
            answer_id: 0,            
        };
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
          axios.get('/get-psycho-test-info/'+this.$route.params.id, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.description = res.data.info[0].description
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        generateRandomNumber(_length) {
            let number = "";
            for (let i = 0; i < _length; i++) {
              if (i == 0) 
                number += 1 + Math.floor(Math.random() * 9); 
              else
                number += Math.floor(Math.random() * 10);                 
            }
            return number;
        },        
        startTest() {
            this.attemptsCount = 0
            this.attemptsSuccesful = 0
            this.currentDigitCount = 2
            this.currentError = 0
            this.answer_id = 0

            this.nextNumber()
        },
        nextNumber() {            
          this.status = 1
          this.userInput = ""
          this.attemptsCount++
          this.displayedNumber = this.generateRandomNumber(this.currentDigitCount)
          this.progress = 100

          let cycles = 5 * this.currentDigitCount; // Interval na zníženie progressu
          let stepp = Math.round(100 / cycles)
            
          // Progress bar interval
          this.interval = setInterval(() => {
              if (this.progress > 0) {
                this.progress -= stepp
              } else {
                clearInterval(this.interval);
                this.status = 2
                setTimeout(() => {
                  this.$refs.tta.focus()                  
                },300)
              }
            }, 200);
        },
        checkAnswer() {
          this.status = 3
          this.answers.push( {
            orig: this.displayedNumber,
            user: this.userInput,
            corr: this.displayedNumber == this.userInput ? 1:0,
            time: new Date().getTime()
          })

          if (this.userInput == this.displayedNumber) {
              this.attemptsSuccesful++                
          } else {
              this.currentError++
              if (this.currentError == this.maxErrors) {
                  this.finishEvaluation()
                  return
              }
          }

            if (this.attemptsCount == 9 * this.lengthAttempts) {
                this.finishEvaluation()
                return
            }

            if (this.attemptsCount % this.lengthAttempts == 0) {
                this.currentDigitCount++
            }
            setTimeout(() => {
              this.nextNumber();
             },2000)

            this.writeAnswer(0)
        },
        finishEvaluation() {
          this.score = Math.round(this.attemptsSuccesful / 9 / this.lengthAttempts * 10000) /100
          this.writeAnswer(1)
          this.status = 4
        },
        closeTest() {
          this.$router.push({name:'cognitive_tests', params: {}}) 
        },
        writeAnswer(_final) {
          const _data = {
                id: this.answer_id,
                test_id: this.$route.params.id,
                score: Math.round(this.attemptsSuccesful / 9 / this.lengthAttempts * 10000) /100,
                answers : JSON.stringify(this.answers),
                final: _final
            } 
            axios.post('/write-my-psycho-test-answer', _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.answer_id = res.data.answer_id
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        }
    },

}
</script>

